export default __webpack_public_path__ + "static/media/enableTick.e7ec5645.svg";